<ng-container [formGroup]="formGroup">
  <div class="overlay"
       [style.opacity]="opacity"
       [ngStyle]="style"
       [hidden]="!isVisible"
       *ngIf="['input', 'select'].includes(field.type)"
       [style.left.%]="position.x"
       [style.top.%]="position.y"
  >
    <label [for]="field.uid">
      <span [ngStyle]="{fontSize: style && style.fontSize ? style.fontSize : '', textDecoration: field.font.underline ? 'underline' : 'none'}">{{field.label}}</span> <span [ngStyle]="{fontSize: style && style.fontSize ? style.fontSize : ''}" *ngIf="field.required && ['input', 'select'].includes(field.type)" class="required-star">*</span>
    </label>

    <input *ngIf="field.type === 'input'"
           type="{{field.type}}"
           [id]="field.uid"
           [name]="field.uid"
           [formControlName]="field.uid"
           (focus)="onInputFocusChange(false, field.type)"
           [ngClass]="{'is-invalid': formGroup && formGroup.get(field.uid) && formGroup.get(field.uid).hasError('required')
            && isValidationErrorDisplayed}"
           [ngStyle]="{borderRadius: field.borderRadius + 'px'}"
           (blur)="onInputFocusChange(true, field.type)"
           class="custom-input"
    >

    <select *ngIf="field.type === 'select'"
            [id]="field.uid"
            [name]="field.uid"
            [ngClass]="{'is-invalid': formGroup && formGroup.get(field.uid) && formGroup.get(field.uid).hasError('required')
             && isValidationErrorDisplayed}"
            [ngStyle]="{borderRadius: field.borderRadius + 'px'}"
            [formControlName]="field.uid"
            (focus)="onInputFocusChange(false, field.type)"
            (blur)="onInputFocusChange(true, field.type)"
            (change)="onInputFocusChange(true, field.type); onSelectionChange($event);"
    >
      <option *ngIf="isSafari()" selected disabled hidden></option>
      <option *ngFor="let option of field.options" ngValue="{{option}}">
        {{option}}
      </option>
    </select>

    <div class="danger-msg" *ngIf="formGroup && formGroup.get(field.uid) && formGroup.get(field.uid).hasError('required')
     && isValidationErrorDisplayed">
      <sup>*</sup>
      {{ 'MESSAGES.FIELD_REQUIRED' | translate }}
    </div>
  </div>

  <div class="overlay css-label"
       [style.opacity]="opacity"
       [ngStyle]="style"
       [hidden]="!isVisible"
       *ngIf="field.type === 'checkbox'"
       [style.left.%]="position.x"
       [style.top.%]="position.y"
  >
    <label [for]="field.uid" class="container-checkbox">
      <input *ngIf="field.type === 'checkbox'"
             type="{{field.type}}"
             [id]="field.uid"
             [name]="field.uid"
             [formControlName]="field.uid"
             (focus)="onInputFocusChange(false, field.type)"
             (blur)="onInputFocusChange(true, field.type)"
             [checked]="isChecked"
             (change)="onChangeCheckbox()"
      >
      <span class="checkmark" [ngStyle]="{borderRadius: field.borderRadius + 'px', width: calculateCheckboxSize(),
           height: calculateCheckboxSize(), marginRight: '5px'}"></span>
      <span [ngStyle]="{fontSize: style && style.fontSize ? style.fontSize : ''}">{{field.label}}</span>
      <span *ngIf="field.required && ['input', 'select'].includes(field.type)" class="required-star">*</span>
    </label>
  </div>

  <div class="overlay button-overlay submit"
       *ngIf="isVisible && field.type === 'submit' && !isSubmitted"
       [hidden]="isSubmitted || !isVisible"
       [ngStyle]="getStyle(isHoverState)"
       (click)="onSubmit()"
       (mouseenter)="toggleHoverState()"
       (mouseleave)="toggleHoverState()"
       [style.opacity]="opacity"
       [id]="field.uid"
       [style.left.%]="position.x"
       [style.top.%]="position.y"
       [attr.data-tracking-id]="field.reportingId"
  >
    <span class="text" [innerHTML]="field.html | safeHtml"></span>
  </div>

  <div class="submit"
       *ngIf="isVisible && field.type === 'submit' && !isSubmitted && !field.reportingId"
       (click)="onSubmit()">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 75 75" style="enable-background:new 0 0 75 75;" xml:space="preserve">
        <style type="text/css">
            .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0.6;stroke:#C0C0C0;stroke-width:3;}
            .st1{fill:#FFFFFF;}
        </style>
        <g id="skip">
            <circle id="Oval" class="st0" cx="37.5" cy="37.5" r="35.5"/>
            <path id="_xEC0D_" class="st1" d="M26.9,51.9c0.4,0,0.7-0.2,1.1-0.4c4.2-2.9,10.4-7.3,18.8-13.1c0.5-0.4,0.7-0.9,0.7-1.5
                s-0.2-1.1-0.7-1.5c-3.1-2.2-9.4-6.6-18.8-13.1c-0.4-0.3-0.7-0.4-1.1-0.4c-0.3,0-0.6,0.1-0.9,0.2c-0.7,0.4-1,0.9-1,1.7V50l0,0
                c0,0.7,0.3,1.3,1,1.7C26.3,51.8,26.6,51.9,26.9,51.9z M53.1,51.9c0.6,0,1-0.2,1.3-0.5C54.8,51,55,50.6,55,50V23.8l0,0
                c0-0.6-0.2-1-0.5-1.3c-0.3-0.4-0.8-0.5-1.3-0.5s-1,0.2-1.3,0.5c-0.4,0.3-0.5,0.8-0.5,1.3V50l0,0c0,0.6,0.2,1,0.5,1.3
                C52.1,51.7,52.6,51.9,53.1,51.9z"/>
        </g>
    </svg>
  </div>
</ng-container>
